export enum Variant {
  Warning = 'warning',
  Restricted = 'restricted',
}

export enum CallDirection {
  Outgoing = 'outgoing',
  Incoming = 'incoming',
  Both = 'both',
}

export enum CallingRestrictionStatus {
  ACTIVE = 'ACTIVE',
  VIOLATED = 'VIOLATED',
  RESTRICTED = 'RESTRICTED',
}
export interface CallRestrictionResult {
  integrationId: string;
  displayName: string;
  callingStatus: CallingRestrictionStatus;
  callingRestrictions: {
    restrictionType: string;
    expiration?: number;
  }[];
  callingViolations: {
    violationType: string;
    expiration?: number;
  }[];
}

export interface CallRestrictionsResponse {
  success: boolean;
  results: CallRestrictionResult[];
}
